export const columns = [
  {
    label: '序号',
    value: 'num',
    width: '55px',
    fixed: 'left',
    align: 'center'
  },
  {
    label: '用户ID',
    value: 'complexId', // 微信Id/浏览器Id
    width: '100px',
    fixed: 'left'
  },
  {
    label: '答卷ID',
    value: 'id',
    width: '180px',
    fixed: 'left'
  },
  {
    label: '流水编号',
    value: 'serialNumber',
    width: '150px'
  },
  {
    label: '开始答题时间',
    value: 'surveyStartTime',
    width: '180px'
  },
  {
    label: '提交时间',
    value: 'submitTime',
    width: '180px'
  },
  {
    width: 280,
    label: '答卷位置',
    value: 'surveyRegion',
    tooltip: 'false'
  },
  {
    width: 150,
    label: '回收渠道',
    value: 'channel',
    tooltip: 'false'
  },
  {
    width: 210,
    label: '子渠道',
    value: 'answerChannel',
    tooltip: 'false'
  },
  {
    width: 100,
    label: '说明',
    value: 'Explain',
    tooltip: 'false'
  },
  {
    label: '操作',
    value: 'opt',
    fixed: 'right'
  }
]
// 已审答卷
export const columns_approved = [
  {
    label: '序号',
    value: 'num',
    width: '55px',
    fixed: 'left'
  },
  {
    label: '用户ID',
    value: 'complexId', // 微信Id/浏览器Id
    width: '100px',
    fixed: 'left'
  },
  {
    label: '答卷ID',
    value: 'id',
    width: '180px',
    fixed: 'left'
  },
  /* {
    label: '流水编号',
    value: 'serialNumber',
    width: '150px'
  }, */
  {
    label: '开始答题时间',
    value: 'surveyStartTime',
    width: '180px'
  },
  {
    label: '提交时间',
    value: 'submitTime',
    width: '180px'
  },
  {
    width: 100,
    label: "答题时长(s)",
    value: "surveyDuration",
  },
  {
    width: 280,
    label: '答卷位置',
    value: 'surveyRegion',
    tooltip: 'false'
  },
  {
    width: 150,
    label: '回收渠道',
    value: 'channel',
    tooltip: 'false'
  },
  {
    width: 210,
    label: '子渠道',
    value: 'answerChannel',
    tooltip: 'false'
  },
  {
    width: 150,
    label: "流程状态",
    value: "status", 
  },
  {
    width: 150,
    label: '操作',
    value: 'opt',
    fixed: 'right'
  }
]
// 已审答卷 20251014dingzhi
export const columns_approved_20251014 = [
  {
    label: '序号',
    value: 'num',
    width: '55px',
    fixed: 'left'
  },
  // {
  //   label: '用户ID',
  //   value: 'complexId', // 微信Id/浏览器Id
  //   width: '100px',
  //   fixed: 'left'
  // },
  {
    label: '答卷ID',
    value: 'id',
    width: '180px',
    fixed: 'left'
  },
  /* {
    label: '流水编号',
    value: 'serialNumber',
    width: '150px'
  }, */
  // {
  //   label: '开始答题时间',
  //   value: 'surveyStartTime',
  //   width: '180px'
  // },
  // {
  //   label: '提交时间',
  //   value: 'submitTime',
  //   width: '180px'
  // },
  // {
  //   width: 100,
  //   label: "答题时长(s)",
  //   value: "surveyDuration",
  // },
  // {
  //   width: 280,
  //   label: '答卷位置',
  //   value: 'surveyRegion',
  //   tooltip: 'false'
  // },
  // {
  //   width: 150,
  //   label: '回收渠道',
  //   value: 'channel',
  //   tooltip: 'false'
  // },
  // {
  //   width: 210,
  //   label: '子渠道',
  //   value: 'answerChannel',
  //   tooltip: 'false'
  // },
  {
    width: 150,
    label: "流程状态",
    value: "status", 
  },
  // {
  //   width: 150,
  //   label: '操作',
  //   value: 'opt',
  //   fixed: 'right'
  // }
]
